import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const WXGuideLayer = Loadable({
    loader: () => import(/* webpackChunkName: "WXGuideLayer" */ './wxGuideLayer'),
    loading: () => <div />,
});
